import React, {useRef, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {showToast} from '../../common/app_common';
import {postApiUserSignup} from '../../common/fetch_api/api_common';

export const AddUser = ({show, handleClose, update }) => {

    const username = useRef('');
    const password = useRef('');
    const confirm = useRef('');

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
        if(username.current.value === '')
        {
            showToast("The Name must not be empty", 'error');
        }
        else
        {
            if(password.current.value === confirm.current.value)
            {
                Promise.resolve( postApiUserSignup(username.current.value, password.current.value) )
                .then( done => {
                    closeModal();
                    update();
                });
            }
            else
            {
                showToast("The passwords don't match", 'error');
            }
        }
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Add User</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='control-users-modal'>
                    <div className="d-flex">
                        <div className="col-4 label-box">Username</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="text" ref={username}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Password</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="password" ref={password}/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-4 label-box">Confirm Password</div>
                        <div className="col-8">
                            <input className="form-control input-box" type="password" ref={confirm}/>
                        </div>
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Add</Button>
            </Modal.Footer>
        </Modal>
    );
};